<div class="about-us-page">

    <!-- Hero Banner -->
    <section class="about-hero">
        <div class="hero-overlay">
            <div class="hero-content">
                <span class="hero-label">Tentang Kami</span>
                <h1 class="hero-title">Visidea Studio</h1>
                <p class="hero-subtitle">Penyedia Layanan Event Terintegrasi untuk Berbagai Acara</p>
            </div>
        </div>
        <div class="hero-wave">
            <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
                <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#ffffff" />
            </svg>
        </div>
    </section>

    <!-- Main Content -->
    <section class="about-main">
        <div class="about-main-inner">

            <!-- Siapa Kami Section -->
            <div class="siapa-kami-grid">
                <div class="siapa-kami-text">
                    <h2 class="section-title">About Us</h2>
                    <p class="section-desc">
                        Visidea Studio adalah Event Organizer dan Creative Event Solution yang
                        menghadirkan pengalaman acara yang berkesan melalui layanan inovatif dan
                        terintegrasi. Kami menyediakan berbagai kebutuhan event mulai dari
                        photobooth, videobooth, web ticketing, undangan digital, hingga solusi kreatif
                        lainnya yang dirancang untuk meningkatkan interaksi dan pengalaman tamu.
                        <br>
                        <br>
                        Dengan sentuhan estetik dan interaktif, Visidea hadir untuk menciptakan
                        pengalaman yang berkesan dan membawa setiap momen menjadi lebih
                        hidup serta dan tak terlupakan.
                    </p>
                </div>

                <div class="siapa-kami-image">
                    <img src="/assets/visidea/partnership1.png" alt="Visidea Studio Partnership">
                </div>
            </div>

            <!-- Stats Row -->
            <div class="stats-row">
                <div class="stat-card">
                    <div class="stat-number">500<span>+</span></div>
                    <div class="stat-label">Event Sukses</div>
                </div>
                <div class="stat-divider"></div>
                <div class="stat-card">
                    <div class="stat-number">1000<span>+</span></div>
                    <div class="stat-label">Pelanggan Puas</div>
                </div>
                <div class="stat-divider"></div>
                <div class="stat-card">
                    <div class="stat-number">3<span>+</span></div>
                    <div class="stat-label">Tahun Pengalaman</div>
                </div>
                <div class="stat-divider"></div>
                <div class="stat-card">
                    <div class="stat-number">10<span>+</span></div>
                    <div class="stat-label">Kota Terlayani</div>
                </div>
            </div>

        </div>
    </section>

    <!-- Vision & Mission -->
    <section class="vismis-section">
        <div class="vismis-inner">
            <div class="vismis-card vismis-vision">
                <h3>Visi Kami</h3>
                <p>Menjadi penyedia layanan event terintegrasi terdepan di Indonesia dengan teknologi inovatif yang
                    memberikan pengalaman tak terlupakan.</p>
            </div>
            <div class="vismis-card vismis-mission">
                <h3>Misi Kami</h3>
                <ul>
                    <li>Memberikan layanan berkualitas tinggi dengan teknologi terkini</li>
                    <li>Menghadirkan inovasi berkelanjutan untuk kebutuhan event</li>
                    <li>Membangun kepercayaan pelanggan melalui layanan profesional</li>
                </ul>
            </div>
        </div>
    </section>

    <!-- Contact Strip -->
    <section class="contact-strip">
        <div class="contact-strip-inner">
            <p class="contact-strip-text">Siap untuk membuat acara Anda lebih berkesan?</p>
            <div class="contact-links">
                <a href="https://www.instagram.com/visideastudio/" class="contact-link" target="_blank">
                    <img src="/assets/visidea/instagram.png" alt="Instagram">
                    <span>&#64;visideastudio</span>
                </a>
                <a href="https://www.tiktok.com/@visidea.studio" class="contact-link" target="_blank">
                    <img src="/assets/visidea/tik-tok.png" alt="TikTok">
                    <span>&#64;visidea.studio</span>
                </a>
                <a href="https://wa.me/6282260084847?text=Halo%2C%20saya%20tertarik%20untuk%20memesan%20PhotoBooth.%20Bisa%20bantu%20saya%20dengan%20informasi%20lebih%20lanjut%20mengenai%20paket%20ini%3F%20Terima%20kasih!" class="contact-link" target="_blank">
                    <img src="/assets/visidea/whatsapp.png" alt="WhatsApp">
                    <span>0822-6008-4847</span>
                </a>
            </div>
        </div>
    </section>

</div>